// Shared with the export's "Vendor Stats" sheet (export-data lambda) so the
// sheet's values format exactly like the tiles' — re-exported here to keep
// the dashboard's historical import sites stable.
export { formatDays, MONTH_LABELS } from "encamp-shared/src/waste/vendorStatsFormat";

// Encamp began tracking correction requests in-app on January 1, 2026 —
// earlier years were tracked outside Encamp, so an empty pre-2026 year is
// expected history, not a data gap.
export const CORRECTION_TRACKING_START_YEAR = 2026;

// Kept short: the monthly chart renders this in MUI's no-data overlay, which
// neither wraps nor clips gracefully.
export function correctionDataEmptyMessage(shippedYear: number): string {
  if (shippedYear < CORRECTION_TRACKING_START_YEAR) {
    return `Correction requests before ${CORRECTION_TRACKING_START_YEAR} were tracked outside Encamp.`;
  }
  return `Correction-request data is not tracked for ${shippedYear}.`;
}

// Same epoch as correction requests: discrepancy tracking (and therefore
// closure timing) starts with the in-app system in 2026.
export function closureDataEmptyMessage(shippedYear: number): string {
  if (shippedYear < CORRECTION_TRACKING_START_YEAR) {
    return `Discrepancies before ${CORRECTION_TRACKING_START_YEAR} were tracked outside Encamp.`;
  }
  return `No resolved e-Manifest corrections for ${shippedYear}.`;
}

// Months to draw on the x-axis: all 12 for past years, but only the months
// that have actually elapsed for the current year — a full Jan–Dec axis in
// June reads as six months of missing data. Any month that already has data
// is never hidden, even if it lands beyond the elapsed window.
export function lastVisibleMonth(shippedYear: number, monthsWithData: number[]): number {
  const now = new Date();
  let elapsed = 12;
  if (shippedYear === now.getFullYear()) {
    elapsed = now.getMonth() + 1;
  } else if (shippedYear > now.getFullYear()) {
    elapsed = 1;
  }
  return Math.min(12, Math.max(elapsed, ...monthsWithData, 1));
}

// shippedDate omnisearch supports `YYYY-MM-DD..YYYY-MM-DD` ranges; build a
// single-month window so clicking a chart point narrows the manifests grid
// to that month.
export function monthShippedDateRange(shippedYear: number, month: number): string {
  const mm = String(month).padStart(2, "0");
  const lastDay = String(new Date(Date.UTC(shippedYear, month, 0)).getUTCDate()).padStart(2, "0");
  return `${shippedYear}-${mm}-01..${shippedYear}-${mm}-${lastDay}`;
}
